import React, {useState, useEffect} from "react";
import { Container, Row, Col } from "react-bootstrap";
import PropertyCard from "../PropertyCard/PropertyCard";
import Slider from "react-slick";
import { ApiRequest } from "../../common/utils/api_request_utils";

import "../Features/Features.scss";

const SimilarProperty = ({property_data}) => {
    const [propItems, setPropItems] = useState([])

    useEffect(() => {
        if(property_data?.id){
            ApiRequest({
                method: "GET",
                url: `${process.env.GATSBY_STRAPI_SRC}/stb-lists/item/property-details?pid=${property_data?.id}`
            }, (result) => {
                if (result.length > 0) {
                    setPropItems(result)
                }
            })
        }
    }, [property_data]);
    
    var settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    dots: false,
                    arrows: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    dots: true,
                    arrows: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    dots:true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <React.Fragment>
            {propItems.length > 0 && 
            <section className="features similar_property">
                <Container>
                    <Row>
                        <Col>
                            <h2>Properties that may also interest you</h2>
                            <div className="tab-wrapper">
                                
                                <Slider {...settings}>
                                    {propItems?.map((item, index) => (
                                        <PropertyCard key={index} FeaturesList={item} />
                                    ))}
                                </Slider>
                            
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            }
        </React.Fragment>
    );
};
export default SimilarProperty;
